var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowStraight = function SvgArrowStraight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78 188"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42.8 186.7 7.5-7.6c.3-.3.3-.9 0-1.3l-1.3-1.3c-.3-.3-.9-.3-1.3 0l-5.6 5.6c-.6.6-1.5.2-1.5-.6V.9c0-.5-.4-.9-.9-.9h-1.8c-.5 0-.9.4-.9.9v180.7c0 .8-1 1.2-1.5.6l-5.5-5.5c-.3-.3-.9-.3-1.3 0l-1.3 1.3c-.3.3-.3.9 0 1.3l7.4 7.5c.8.8 2 1.3 3.1 1.3h1.4c1.5-.1 2.7-.6 3.5-1.4"
  })));
};
export default SvgArrowStraight;